import { Component, OnInit, inject } from '@angular/core';
import {
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
})
export class ProfileComponent implements OnInit {
  private router = inject(Router);


  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      // if (event instanceof NavigationStart) {
      //   // console.log('Navigation started');
      // }
      // if (event instanceof NavigationEnd) {
      //   // console.log('Navigation ended');
      // }
      // if (event instanceof NavigationError) {
      //   console.error('Navigation error', event.error);
      // }
    });
  }
}
